




















































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { VeeValidateObserverRef } from '@/models/Common/Validation'
import UserService from '@/services/UserService'
import moment from 'moment'

@Component
export default class ShowPersonalInfo extends Vue {
  @Prop() personalInfo!: any
  $refs!: {
    observer: VeeValidateObserverRef
  }
  errorBirthdayMsg: boolean = false
  private checkBirthDate: boolean = false
  showPersonalInfo: boolean = true
  public years: any[] = []
  public days: any[] = []
  public months: any[] = []

  public gender_options: any[] = [
    {
      id: 1,
      text: this.$t('common.select.not_set'),
      value: null
    },
    {
      id: 2,
      text: this.$t('setting.change_profile.female'),
      value: 0
    },
    {
      id: 3,
      text: this.$t('setting.change_profile.male'),
      value: 1
    }
  ]

  public birthday_options: any[] = [
    {
      id: 1,
      text: this.$t('common.select.private'),
      value: 0
    },
    {
      id: 2,
      text: this.$t('common.select.public'),
      value: 1
    }
  ]

  public prefecture_options: any[] = [
    {
      id: 1,
      text: this.$t('common.select.private'),
      value: 0
    },
    {
      id: 2,
      text: this.$t('common.select.public'),
      value: 1
    }
  ]

  created() {
    this.getYears()
    this.getDays()
    this.getMonths()
  }

  async postcodeSearch(isError: string) {
    if (isError) {
      return
    }
    
    try {
      const res = await UserService.getZipCode(this.personalInfo.zipcode)
      this.$emit('onPostCodeSearch', {
        prefecture: res.data.province_name,
        city: res.data.district_name,
        other_address: res.data.city_name
      })
    } catch (err) {
      console.log(err)
    }
  }

  updatePersonalInfo() {
    if (
      this.personalInfo.birthday_year !== null &&
      this.personalInfo.birthday_month !== null &&
      this.personalInfo.birthday_day !== null
    ) {
      let birthday =
        this.personalInfo.birthday_year +
        '/' +
        this.personalInfo.birthday_month +
        '/' +
        this.personalInfo.birthday_day
      this.checkBirthDate = moment(birthday, 'YYYY/MM/DD').isValid()
    }
    if (
      this.personalInfo.birthday_year === null &&
      this.personalInfo.birthday_month === null &&
      this.personalInfo.birthday_day === null
    ) {
      this.checkBirthDate = true
    }
    this.$refs.observer.validate().then(isValidate => {
      if (!isValidate) {
        return
      } else if (this.checkBirthDate === false) {
        this.errorBirthdayMsg = true
        return
      } else {
        const new_personal_info = {
          gender: this.personalInfo.gender,
          birthday_year: this.personalInfo.birthday_year,
          birthday_month: this.personalInfo.birthday_month,
          birthday_day: this.personalInfo.birthday_day,
          birthday_option: this.personalInfo.birthday_option,
          nearest_station: this.personalInfo.nearest_station,
          zipcode: this.personalInfo.zipcode,
          prefecture: this.personalInfo.prefecture,
          prefecture_option: this.personalInfo.prefecture_option,
          city: this.personalInfo.city,
          other_address: this.personalInfo.other_address,
          building_name: this.personalInfo.building_name,
          phone: this.personalInfo.phone,
          url: this.personalInfo.url
        }
        this.checkBirthDate = false
        this.$emit('onUpdatePersonalInfo', new_personal_info)
      }
    })
  }

  addPhoneNumberField() {
    if (this.personalInfo.phone.length < 10) {
      this.$emit('onAddPhoneNumberField')
    }
  }

  addUrlField() {
    if (this.personalInfo.url.length < 10) {
      this.$emit('onAddUrlField')
    }
  }

  removePhoneNumberField(index: any) {
    this.$emit('onRemovePhoneNumberField', index)
  }

  removeUrlField(index: any) {
    this.$emit('onRemoveUrlField', index)
  }

  updatePersonalField({
    field,
    index,
    value
  }: {
    field: string
    index?: number
    value: any
  }) {
    const updated = { ...this.personalInfo }

    if (index !== undefined) {
      updated[field] = [...updated[field]]
      updated[field][index] = value
    } else {
      updated[field] = value
    }

    this.$emit('updatePersonalField', updated)
  }

  getDays() {
    for (let i = 0; i < 31; i++) {
      this.days.push({
        id: i + 1,
        value: i + 1,
        text: i + 1
      })
    }
    let default_option = {
      id: -1,
      value: null,
      text: this.$t('common.select.not_set')
    }
    this.days.unshift(default_option)
  }

  getMonths() {
    for (let i = 0; i < 12; i++) {
      this.months.push({
        id: i + 1,
        value: i + 1,
        text: i + 1
      })
    }
    let default_option = {
      id: -1,
      value: null,
      text: this.$t('common.select.not_set')
    }
    this.months.unshift(default_option)
  }

  getYears() {
    const currentYear = new Date().getFullYear()
    for (let i = 1945; i <= currentYear; i++) {
      this.years.push({
        id: i,
        value: i,
        text: i
      })
    }
    let default_option = {
      id: -1,
      value: null,
      text: this.$t('common.select.not_set')
    }
    this.years.unshift(default_option)
  }

  onZipCodeInputNumberOnly(event: any) {
    const raw = event.target.value.replace(/[^0-9０-９]/g, '')

    const normalized = raw.replace(/[０-９]/g, (s: string) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )

    event.target.value = normalized
    this.updatePersonalField({
      field: 'zipcode',
      value: event.target.value
    })
  }

  onPhoneNumberInputNumberOnly(event: any, index: number) {
    let value = event.target.value.replace(/[^0-9０-９]/g, '')

    value = value.replace(/[０-９]/g, (s: string) =>
      String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    )

    event.target.value = value
    this.updatePersonalField({
      field: 'phone',
      index,
      value: event.target.value
    })
  }
}
